"use client";

import { useTranslations } from "next-intl";
import { packageKeys } from "@/lib/brand";
import { MegaMenu } from "./MegaMenu";
import { IllustrationVisual } from "./IllustrationVisual";
import { packageIllustrations } from "./illustrations/packageIllustrations";
import { usePackageCopy } from "./packageCopy";

/**
 * "Services" mega menu — one card per package (website, iOS, custom), same
 * art and copy as the offerings section.
 */
export function ServicesMegaMenu() {
  const t = useTranslations("header");
  const copyFor = usePackageCopy();

  const items = packageKeys.map((key) => {
    const Illustration = packageIllustrations[key];
    const copy = copyFor(key);
    return {
      key,
      href: "#services",
      visual: (
        <IllustrationVisual>
          <Illustration />
        </IllustrationVisual>
      ),
      title: copy.title,
      detail: copy.detail,
      cta: t("servicesCta"),
    };
  });

  return <MegaMenu label={t("nav.services")} items={items} />;
}
